module.exports = __webpack_public_path__ + "./fonts/GD-DOTFONT-DQ-OTF_008.otf";